const common = {
  "site.name": "Hoobuy Lifestyle",
  "site.tagline": "Planilha Hoobuy em Português",
};

export default common;